import { render, staticRenderFns } from "./SuccessfullReg.vue?vue&type=template&id=e3067d28&scoped=true&"
import script from "./SuccessfullReg.vue?vue&type=script&lang=js&"
export * from "./SuccessfullReg.vue?vue&type=script&lang=js&"
import style0 from "./SuccessfullReg.vue?vue&type=style&index=0&id=e3067d28&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3067d28",
  null
  
)

export default component.exports